import { useCallback, useEffect, useRef } from 'react'

export function useResetFieldOnMethodChange<T extends { clear(): void }>(currentMethod: string) {
  const eleRef = useRef<T | null>(null)
  const onReady = useCallback((ele: T) => {
    eleRef.current = ele
  }, [])
  useEffect(() => {
    if (!eleRef.current) return
    eleRef.current.clear()
  }, [currentMethod])
  return onReady
}
